<template>
    <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
        <b-modal v-model="modalAberto" :title="title" header-bg-variant="secondary" header-text-variant="light"
            @hide="closeModal" centered>
            <b-form @submit.prevent="handleSubmit(prorrogar)">
                <b-container>
                    <b-row>
                        <b-col cols="12">
                            <default-form-validation-provider label="Ato de prorrogação:">
                                <b-form-file placeholder="Nenhum arquivo selecionado" v-model="anexoAtoProrroga"
                                    accept=".pdf"></b-form-file>
                            </default-form-validation-provider>
                        </b-col>
                    </b-row>
                </b-container>
            </b-form>
            <template #modal-footer>
                <b-button size="sm" variant="outline-secondary" @click="closeModal">Cancelar</b-button>
                <b-button size="sm" variant="secondary" type="submit" @click="handleSubmit(prorrogar)"
                    :disabled="!anexoAtoProrroga">
                    Prorrogar concurso
                </b-button>
            </template>
        </b-modal>
    </validation-observer>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { Component, Vue, Prop } from "vue-property-decorator";
import concursoService from "@/services/atos-pessoal/concursoService";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";

@Component({
    components: {
        ValidationObserver,
        DefaultFormValidationProvider
    },
})
export default class ModalProrrogar extends mixins(UtilsTS, Vue) {
    @Prop({ required: true }) edital!: any;
    @Prop({ required: true }) title!: string;

    modalAberto = true
    anexoAtoProrroga: File | null = null;

    async prorrogar() {
        try {
            const response = await concursoService.prorrogarConcurso(this.edital.IdEdital, this.anexoAtoProrroga)
            if (response) this.$toast.success("Concurso prorrogado com sucesso!")
            this.closeModal()
        } catch (error: any) {
            this.tratarError(error)
            console.error("Erro ao prorrogar", error);
        } finally {
            this.$emit("reload")
        }
    }

    closeModal() {
        this.$emit("close");
    }
}
</script>